<template>
  <div class="team-details">
    <div class="team-details-left">
      <div
        class="team-row"
        :class="{ 'is-active': activeIndex === index }"
        v-for="(item, index) in teamList"
        :key="index"
        @click="selectWarehouse(item, index)"
      >
        <div class="team-row-title">
          <img
            class="warehouse-img"
            src="~assets/images/warehouse/warehouse-orange.png"
          />
          <span class="name" :title="item.name">{{ item.name }}</span>
        </div>
        <div class="nums-info">
          <div class="goods-shelves">
            <p class="goods-shelves-nums">{{ item.teamNums }}</p>
            <p class="goods-shelves-title">班组数量（个）</p>
          </div>
          <div class="goods-shelves">
            <p class="goods-shelves-nums">{{ item.peopleNums }}</p>
            <p class="goods-shelves-title">班组人数（人）</p>
          </div>
        </div>
      </div>
    </div>
    <div class="team-details-right">
      <div class="team-details-right-top">
        <div class="team-details-right-top-search">
          <span class="team-details-right-top-search-title">日期：</span>
          <el-date-picker
            v-model="date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
          <el-button icon="el-icon-search" class="btn-blue" @click="searchData"
            >搜索</el-button
          >
        </div>
        <div class="btn-container">
          <div class="usergroup" @click="toBeAllocated">
            <span class="usergroup-img"></span>
            <span>待分配组员</span>
          </div>
        </div>
      </div>
      <div class="team-details-right-content">
        <div
          class="team-members"
          v-for="(item, index) in teamMembersList"
          :key="index"
        >
          <div class="team-members-name">
            <img class="user-img" src="~assets/images/team/user.png" />
            <span>{{ item.name }}</span>
            <span class="production-line-name" :class="{'production-line-name-active': item.productionLineName === '未入驻'}">（当前产线：{{item.productionLineName}}）</span>
          </div>
          <div class="team-members-main">
            <div
              v-show="item.list.length"
              class="team-members-list"
              :class="{'team-members-list-hover':j.status==2}"
              v-for="(j, jIndex) in item.list"
              :key="jIndex"
            >
              <div class="team-members-list-container">
                <img class="status-img" :src="j.img">
                <span class="team-members-list-name">{{ j.name }}</span>
              </div>
              <span class="leave" @click="leaveFnc(j.teamMemberId)">
                <img class="leave-img" src="~assets/images/team/leave.png">
                移至待分配
              </span>
            </div>
            <div class="nothing-production" v-show="!item.list.length">
              <img class="user-clear" src="~assets/images/user/user-clear.png">
              暂无组员，请让组长通知组员签到
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 待分配组员 -->
    <el-drawer
      :title="`待分配组员(${allocatedList.length})`"
      class="allocated-drawer"
      :visible.sync="drawer"
      :wrapperClosable="false"
      :before-close="handleCloseDrawer">
      <div class="content">
        <div 
          class="row"
          v-for="(item, index) in allocatedList"
          :key="index"
        >
          <div class="row-info row-info1">
            <img class="row-img" src="~assets/images/team/user2.png">
            <span>{{ item.name }}</span>
          </div>
          <div class="row-info row-info2">
            <img class="row-img" src="~assets/images/team/call.png">
            <span>{{ item.phone }}</span>
          </div>
          <div class="row-info row-info3">
            <img class="row-img" src="~assets/images/team/creditcard.png">
            <span>{{ item.idCard }}</span>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Team from "models/team";
import { formatTimeToDate } from "common/js/util";
export default {
  data() {
    return {
      teamList: [],
      teamMembersList: [],
      activeIndex: 0,
      date: this.timeDefault(),
      teamId: null,
      drawer: false,
      allocatedList: [],
      stausObj: {
        1: require('../../../../../assets/images/team/alienation.png'),
        2: require('../../../../../assets/images/team/work.png'),
        3: require('../../../../../assets/images/team/finish.png'),
        4: require('../../../../../assets/images/team/leave-sign.png')
      },
    };
  },

  async created() {
    await this.initTeamList();
    this.selectWarehouse(this.teamList[0], 0)
  },

  methods: {
    /**
     * @desc 班组仓库列表
     */
    async initTeamList() {
      let date = this.date;
      let res = await Team.getTeamGroupList(date)
      if (res.success) {
        let arr = [];
        res.result.map((i) => {
          let obj = {};
          obj.id = i.warehouseId;
          obj.name = i.warehouseName;
          obj.teamNums = i.teamCount;
          obj.peopleNums = i.memberCount;
          arr.push(obj);
        });
        this.teamList = arr;
      } else {
        this.$message.error(res.message);
      }
    },

    /**
     * @desc 获取组员列表
     */
    initTeamMembersList() {
      let date = this.date;
      let warehouseId = this.teamId;
      let data = {
        date,
        warehouseId,
      };
      Team.getTeamMembersList(data).then(res => {
        if (res.success) {
          let arr = [];
          res.result.map((i) => {
            let obj = {};
            obj.name = i.leaderName;
            obj.productionLineName = i.lineName?i.lineName:'未入驻';
            obj.list = []
            i.memberEntityList.map(j => {
              let obj2 = {}
              obj2.name = j.memberName
              obj2.teamMemberId = j.teamMemberId
              obj2.status = j.status
              obj2.img = this.stausObj[j.status]
              obj.list.push(obj2)
            })
            arr.push(obj);
          });
          this.teamMembersList = arr;
        } else {
          this.$message.error(res.message);
        }
      })
    },

    /** 
     * @desc 待分配组员
    */
    initToBeAllocatedList() {
      let date = this.date;
      let data = {
        date,
      };
      Team.getToBeAllocatedList(data).then(res => {
        if (res.success) {
          let arr = [];
          res.result.map((i) => {
            let obj = {};
            obj.name = i.name;
            obj.phone = i.phoneNumber
            obj.idCard = i.idNumber
            arr.push(obj);
          });
          this.allocatedList = arr;
          this.drawer = true
        } else {
          this.$message.error(res.message);
        }
      })
    },

    /** 
     * @desc 默认到当天的前一天
    */
    timeDefault() {
      let date = new Date();
      const currentDay = formatTimeToDate(date.getTime())
      return currentDay;
    },

    /**
     * @desc 选择班组
     */
    selectWarehouse(row, index) {
      this.teamId = row.id;
      this.activeIndex = index;
      this.initTeamMembersList();
    },

    searchData() {
      this.initTeamList();
      this.initTeamMembersList();
    },

    /** 
     * @desc 查看待分配组员列表
    */
    toBeAllocated() {
      this.initToBeAllocatedList()
    },

    handleCloseDrawer() {
      this.drawer = false
    },

    /**
     * @desc 移至待分配
     */
    leaveFnc(teamMemberId) {
      this.$confirm("移动后，该小组成员将被移至待分配列表，请确认", "移至待分配", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-blue',
        cancelButtonClass: 'btn-gray'
      })
        .then(() => {
          let data = {
            teamMemberId
          };
          Team.postMoveToBeAllocated(data).then(res => {
            if (res.success) {
              this.initTeamMembersList()
            } else {
              this.$message.error(res.message);
            }
          })
        })
        .catch(() => {});
    }
  },
};
</script>

<style lang='scss'>
@import "@/assets/style/layout/production/team-details.scss";
</style>
